const mutations = {
  setModels(state, data) {
    state.convocatorias = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.convocatoria = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.convocatorias.unshift(model);
  },

  updateModel(state, model) {
    const index = state.convocatorias
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.convocatorias.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.convocatorias
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.convocatorias.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
